module.exports = __webpack_public_path__ + "static/media/mobile-alt.300e9cf3.svg";